import Transformer from './../transformer'

export default class HighwayDelegateTransformer extends Transformer {
  static fetch(highwayDelegate) {
    return {
      id: highwayDelegate.id,
      clientName: highwayDelegate.delegate.customer_name,
      client: highwayDelegate.delegate.customer_id,
      delegate: highwayDelegate.delegate.delegate_id,
      delegateName: highwayDelegate.delegate.delegate_name, // Delegate is a object

      // isActive: highwayDelegate.is_active,
      municipality: highwayDelegate.municipality,
      municipalityName: highwayDelegate.municipality_name,
      name: highwayDelegate.name,
      state: highwayDelegate.state,
      stateName: highwayDelegate.state_name,
    }
  }

  static send(highwayDelegate) {
    return {
      id: highwayDelegate.id,
      is_active: true,
      municipality: highwayDelegate.municipality,
      name: highwayDelegate.name,
      delegate: highwayDelegate.delegate,
      state: highwayDelegate.state,
    }
  }
}


// WEBPACK FOOTER //
// ./src/transformers/catalog/highwayDelegate.js